import { PlanoIosPage } from './PlanoIosPage';
import { AppSession } from 'projects/core/src/lib/core/AppSession';
import { PlanoProvider } from 'projects/core/src/lib/core/provider/PlanoProvider';
import { ResponseModel } from 'projects/core/src/lib/core/model/ResponseModel';
import { TratamentoGatewayService } from 'projects/core/src/lib/core/TratamentoGatewayService';
import { UsuarioModel } from 'projects/core/src/lib/core/model/UsuarioModel';
import { ContratoProvider } from 'projects/core/src/lib/core/provider/ContratoProvider';
import { ThrowError } from 'projects/core/src/lib/core/ThrowError';
import { ContratoWrapperModel } from 'projects/core/src/lib/core/model/ContratoWrapperModel';
import { AppStorage } from 'projects/core/src/lib/core/AppStorage';
import { FirebaseCrashlytics } from '@capacitor-community/firebase-crashlytics';

export class PlanoIosPageViewModel {

    constructor() {}

    context: PlanoIosPage
    contratoProvider = new ContratoProvider()

    setContext(context: PlanoIosPage) {
        this.context = context
    }

    getContext(): PlanoIosPage {
        return this.context
    }

    async confirmPurchaseApi(codPlano: String, status: number, codProduto: String, product) {
        const usuarioLogado = await this.obtemUsuarioLogado()
        const planoProvider = new PlanoProvider(usuarioLogado.admin)

        let retorno = await planoProvider.confirmPurchaseApi(codPlano, {
            nome: usuarioLogado.name,
            email: usuarioLogado.email,
            cpf: usuarioLogado.cpf,
            status,
            codProduto,
            tituloProduto: planoProvider.obtemTituloPlanoPorCodigo(codPlano),
        }, product)
        retorno = new TratamentoGatewayService(this.getContext()).builder(retorno)
        if (retorno.status == ResponseModel.STATUS_OK) {
            
        } else {
            throw new Error(ThrowError.MESSAGE_DEFAULT)
        }
    }

    async associateApple(originalTransactionId, receiptData) {
        try {
            const usuarioLogado = await this.obtemUsuarioLogado()
            const planoProvider = new PlanoProvider(usuarioLogado.admin)
            let retorno = await planoProvider.associateApple(originalTransactionId, receiptData)
            retorno = new TratamentoGatewayService(this.getContext()).builder(retorno)
            if (retorno.status == ResponseModel.STATUS_OK) {
                this.removeAssociateAppleLocal()
                return true
            } else if (retorno.status == ResponseModel.STATUS_GATEWAY_ERROR) {
                return false
            } else {
                this.salvaAssociateAppleLocal(originalTransactionId, receiptData)
                throw Error(ThrowError.MESSAGE_DEFAULT)
            }
        } catch(e) {
            this.salvaAssociateAppleLocal(originalTransactionId, receiptData)
            throw Error(e)
        }
    }

    async apiBuscaContratos() {
        try {
            let retorno = await this.contratoProvider.apiListaContratosPorUsuario()
            retorno = new TratamentoGatewayService(this.getContext()).builder(retorno)
            if (retorno.status == ResponseModel.STATUS_OK) {
                await AppStorage.set(AppSession.CHAVE_CONTRATO_USUARIO, retorno.data)
                return retorno.data
            } else {
                await AppStorage.set(AppSession.CHAVE_CONTRATO_USUARIO, new ContratoWrapperModel())
                throw Error(ThrowError.MESSAGE_DEFAULT)
            }
        } catch(e) {
            throw Error(ThrowError.MESSAGE_DEFAULT)
        }
    }

    async salvaAssociateAppleLocal(originalTransactionId, receiptData) {
        FirebaseCrashlytics.recordException({message: `PlanoIosPageViewModel.salvaAssociateAppleLocal - originalTransactionId: ${JSON.stringify(originalTransactionId)} - receiptData: ${JSON.stringify(receiptData)}`})
        AppStorage.set(AppSession.CHAVE_ASSOCIATE_APPLE, {originalTransactionId, receiptData})
    }

    removeAssociateAppleLocal() {
        FirebaseCrashlytics.recordException({message: `PlanoIosPageViewModel.removeAssociateAppleLocal`})
        AppStorage.remove(AppSession.CHAVE_ASSOCIATE_APPLE)
    }

    async obtemUsuarioLogado(): Promise<UsuarioModel> {
        return await AppSession.getUser()
    }
}